"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyNameSchema = void 0;
var _zod = require("zod");
var companyNameSchema = exports.companyNameSchema = function companyNameSchema(t) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var errorMessage = variant === 'payApp' ? t('payApplication.payapp.memorable.error') : t('company.coMngt.companyInfo.company.name.required');
  return _zod.z.object({
    companyName: _zod.z.string().min(1, {
      message: errorMessage
    }).max(43, {
      message: errorMessage
    }).regex(/^[A-Za-z0-9\-&_ ]*$/, {
      message: errorMessage
    })
  });
};